import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar';
import type { InventoryListsListFilters } from '@openx/types/inventoryList';
import { useTranslation } from 'react-i18next';

export const InventoryListsTopBar = () => {
  const { t } = useTranslation();
  const { onFiltersChange, criteria } = useFiltersContext<InventoryListsListFilters>();

  return (
    <TopBar
      filters={criteria.filters as InventoryListsListFilters}
      onChange={onFiltersChange}
      searchText={t('Search Name')}
      useFiltersV2
    />
  );
};
